export default "__VITE_ASSET__PKdJEHYM__"